import { styled } from '@mui/material';
import { MaterialDesignContent } from 'notistack';

export const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: theme.palette.success.light, // #d1fae5
    color: theme.palette.success.dark, // #065f46
    border: `1px solid ${theme.palette.success.main}`, // #10b981
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: theme.palette.error.light, // #fecaca
    color: theme.palette.error.dark, // #dc2626
    border: `1px solid ${theme.palette.error.main}`, // #ef4444
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: theme.palette.warning.light, // #fffbeb
    color: theme.palette.warning.dark, // #d97706
    border: `1px solid ${theme.palette.warning.main}`, // #f59e0b
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: theme.palette.info.light, // #dbeafe
    color: theme.palette.info.dark, // #1d4ed8
    border: `1px solid ${theme.palette.info.main}`, // #3b82f6
  },
}));

export default StyledMaterialDesignContent;
